var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "mb-30px mb-md-40px"
  }, [_c('v-tabs', {
    staticClass: "tab tab--block",
    attrs: {
      "show-arrows": "",
      "grow": ""
    }
  }, [_c('v-tab', {
    on: {
      "click": function click($event) {
        return _vm.select('closeAndOpen');
      }
    }
  }, [_vm._v("종료된 이벤트")]), _c('v-tab', {
    on: {
      "click": function click($event) {
        return _vm.select('winner');
      }
    }
  }, [_vm._v("당첨자 발표")])], 1)], 1), _c('div', {
    staticClass: "my-md-n10px"
  }, [_c('v-row', _vm._l(_vm.boards, function (board) {
    return _c('v-col', {
      key: board._id,
      attrs: {
        "cols": "6",
        "md": "3"
      }
    }, [_c('div', {
      staticClass: "py-md-10px cursor-pointer event-card",
      on: {
        "click": function click($event) {
          return _vm.rows(board);
        }
      }
    }, [_c('div', {
      staticClass: "border"
    }, [_c('v-card', {
      staticClass: "event-card__image",
      attrs: {
        "tile": "",
        "flat": "",
        "img": board.thumb,
        "max-width": "500"
      }
    }, [_c('v-responsive', {
      attrs: {
        "aspect-ratio": 255 / 180
      }
    })], 1)], 1), _c('div', {
      staticClass: "text-center py-12px py-md-16px"
    }, [_c('div', {
      staticClass: "font-size-14 font-size-md-16 font-weight-bold text-truncate"
    }, [_vm._v(_vm._s(board.subject))]), _c('div', {
      staticClass: "font-size-12 font-size-md-14 mt-6px"
    }, [_vm._v(_vm._s("".concat(_vm.$dayjs(board.display.startDate).format("YYYY.MM.DD"), " ~ ").concat(board.display.endDate ? _vm.$dayjs(board.display.endDate).format("YYYY.MM.DD") : "상시진행")))])])])]);
  }), 1)], 1), _c('div', {
    staticClass: "mt-30px mt-md-40px"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }